import React from "react";
import { useDispatch } from "react-redux";
import { message as showMessage } from "../../../../Reducers/loading/actions";
import { 
  importCategoriesAndLocations, 
  importReservations, 
  fetchTommyArtikelen 
} from "../Reducers/actions";

const ImportSection = ({ 
  reserveringssystemen, 
  selectedSystem, 
  setSelectedSystem, 
  importing, 
  setImporting,
  onTommyArtikelenFetched,
  checkCategoriesAvailable
}) => {
  const dispatch = useDispatch();
  const message = (time, type, msg) => dispatch(showMessage(time, type, msg));

  const getSystemDisplayName = (naam) => {
    const displayNames = {
      tommy: "Tommy",
      boekingsexpert: "Boekingsexpert",
      recranet: "RecraNet",
      muws: "Muws",
      maxxton: "Maxxton"
    };
    return displayNames[naam] || naam || 'Naamloos systeem';
  };

  const handleImportCategoriesAndLocations = async (systemId) => {
    if (!systemId) {
      message(3000, "warning", "Selecteer eerst een reserveringssysteem");
      return;
    }
    
    setImporting(true);
    try {
      const result = await dispatch(importCategoriesAndLocations(systemId));
      if (result.type === "success") {
        message(5000, "success", result.message);
        checkCategoriesAvailable();
      } else {
        message(4000, "warning", "Fout bij importeren: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    } finally {
      setImporting(false);
    }
  };

  const handleImportReservations = async (systemId) => {
    if (!systemId) {
      message(3000, "warning", "Selecteer eerst een reserveringssysteem");
      return;
    }
    
    if (!window.confirm("Weet je zeker dat je reserveringen wilt importeren? Dit haalt gastgegevens op en maakt nieuwe stamgegevens aan als deze niet bestaan.")) {
      return;
    }
    
    setImporting(true);
    try {
      const result = await dispatch(importReservations(systemId));
      if (result.type === "success") {
        message(5000, "success", result.message);
      } else {
        message(4000, "warning", "Fout bij importeren reserveringen: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    } finally {
      setImporting(false);
    }
  };

  const handleFetchTommyArtikelen = async (systemId) => {
    if (!systemId) {
      message(3000, "warning", "Selecteer eerst een reserveringssysteem");
      return;
    }

    const selectedSystemData = reserveringssystemen.find(s => s._id === systemId);
    if (selectedSystemData?.naam !== "tommy") {
      message(4000, "warning", "Tommy artikelen kunnen alleen worden opgehaald van Tommy reserveringssystemen");
      return;
    }

    setImporting(true);
    try {
      const result = await dispatch(fetchTommyArtikelen(systemId));
      if (result.type === "success") {
        onTommyArtikelenFetched(result.artikelen);
        message(3000, "success", `${result.count} Tommy artikelen succesvol opgehaald`);
      } else {
        message(4000, "warning", "Fout bij ophalen Tommy artikelen: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="mt-4 p-3 border-top">
      <h5 className="mb-3">
        <i className="fas fa-download me-2"></i>
        Import Functies
      </h5>
      
      <div className="row">
        <div className="col-md-12 mb-3">
          <div className="form-group">
            <label>Selecteer reserveringssysteem voor import:</label>
            <select 
              className="form-control"
              value={selectedSystem || ''}
              onChange={(e) => setSelectedSystem(e.target.value)}
              disabled={importing}
            >
              <option value="">-- Selecteer een systeem --</option>
              {reserveringssystemen.filter(s => s.actief).map(system => (
                <option key={system._id} value={system._id}>
                  {getSystemDisplayName(system.naam)} - {system.url}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <button
            className="btn btn-success btn-block w-100"
            onClick={() => handleImportCategoriesAndLocations(selectedSystem)}
            disabled={!selectedSystem || importing}
          >
            {importing ? (
              <><i className="fas fa-spinner fa-spin me-2"></i>Bezig met importeren...</>
            ) : (
              <><i className="fas fa-download me-2"></i>Importeer Categorieën & Plaatsen</>
            )}
          </button>
          <small className="text-muted d-block mt-1">
            Importeert eerst alle categorieën, daarna automatisch alle bijbehorende plaatsen
          </small>
        </div>
        
        <div className="col-md-4">
          <button
            className="btn btn-primary btn-block w-100"
            onClick={() => handleImportReservations(selectedSystem)}
            disabled={!selectedSystem || importing}
          >
            {importing ? (
              <><i className="fas fa-spinner fa-spin me-2"></i>Bezig met importeren...</>
            ) : (
              <><i className="fas fa-calendar-plus me-2"></i>Importeer Reserveringen</>
            )}
          </button>
          <small className="text-muted d-block mt-1">
            Importeert reserveringen en maakt gastprofielen aan op basis van email
          </small>
        </div>

        <div className="col-md-4">
          <button
            className="btn btn-warning btn-block w-100"
            onClick={() => handleFetchTommyArtikelen(selectedSystem)}
            disabled={!selectedSystem || importing || (selectedSystem && reserveringssystemen.find(s => s._id === selectedSystem)?.naam !== "tommy")}
          >
            {importing ? (
              <><i className="fas fa-spinner fa-spin me-2"></i>Bezig met ophalen...</>
            ) : (
              <><i className="fas fa-list me-2"></i>Toon Tommy Artikelen</>
            )}
          </button>
          <small className="text-muted d-block mt-1">
            Toont alle beschikbare artikelen van het Tommy systeem
          </small>
        </div>
      </div>
    </div>
  );
};

export default ImportSection;